<template>
  <div>
    <div class="pre-formatted">{{ item.text }}</div>
    <!-- <div>{{item}}</div> -->
  </div>
</template>

<script>
export default {
  name: "CargoKanbanCardFixed",
  components: {},
  props: ["item"],
  data: function () {
    return {
      urlChecklist: "",
      accessKey: "",
      urlCte: "",
      urlMap: "",
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
    };
  },
  created: function () {
    if (this.item) {
      if (this.item.url2) {
        this.urlChecklist = this.item.url2;
      } else if (this.item.checklistId) {
        this.urlChecklist = `/trackingShippingCompany/checklist/fill/${this.item.checklistId}`;
        this.loadNewUrl(this.item.checklistId);
      }
    }
  },
  methods: {
    async loadNewUrl(checklistId) {
      if (checklistId) {
        this.$apiChecklist
          .get(`/v2/checklist/get/${checklistId}`)
          .then((response) => {
            let checklist = response.data;
            if (checklist) {
              if (checklist.draft == false) {
                this.urlChecklist = `/trackingShippingCompany/checklist/filled/details/${checklistId}`;
                // this.$router.push({
                //   path: `/trackingShippingCompany/checklist/filled/details/${checklistId}`,
                // });
              }
            }
            // this.$router.push({
            //   path: `/trackingShippingCompany/checklist/fill/${checklistId}`,
            // });
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          });
      }
    },
    modalOpen() {
      this.$refs.openModal.show();
    },
    openModalDanger() {
      this.$refs.openModalDanger.show();
    },
    openNextStage() {
      this.$refs.kanbanEditModal.show();
    },
    generatePdf(model, key) {
      this.modalOpen();
      console.log(key);
      this.accessKey = key;
      if (model == 1)
        this.url = `/GeneratePdf/${this.item.id}/cte/${this.accessKey}`;
      else if (model == 2)
        this.url = `/GeneratePdf/${this.item.id}/mdfe/${this.accessKey}`;
      else this.url = `/GeneratePdf/${this.item.id}/contract/${this.accessKey}`;
      this.$api
        .request({
          url: this.url,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          console.log("response");
          console.log(response);
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide("modal-prevent-closing");
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.$refs.openModal.hide("modal-prevent-closing");
            });
            this.$refs.openModal.hide("modal-prevent-closing");
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log("Load data error");
                this.$refs.openModal.hide("modal-prevent-closing");
              } else if (error.response.status == 500) {
                this.alert.error = "CT-e nã encotrata na GW";
                this.$refs.openModal.hide("modal-prevent-closing");
                this.openModalDanger();
                this.$refs.danger.show();
              } else {
                console.log(error.response.statusText);
                this.$refs.openModal.hide("modal-prevent-closing");
              }
            } else {
              console.log(error.message);
              this.$refs.openModal.hide("modal-prevent-closing");
            }
            this.$refs.openModal.hide("modal-prevent-closing");
          }
        });

      // console.log(this.url.url);
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>

<style>
.pre-formatted {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
